// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"cea6aad4","239":"4028045f","453":"4ce08295","455":"3f0c9f69"}[chunkId] + ".chunk.js";
};